import { render, staticRenderFns } from "./submitSafetyForm.vue?vue&type=template&id=064071c4&scoped=true"
import script from "./submitSafetyForm.vue?vue&type=script&lang=js"
export * from "./submitSafetyForm.vue?vue&type=script&lang=js"
import style0 from "./submitSafetyForm.vue?vue&type=style&index=0&id=064071c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064071c4",
  null
  
)

export default component.exports